module.exports = __webpack_public_path__ + "static/media/chart-doughnut.cbe43391.svg";